import React from 'react';
import SvgIcon from './SvgIcon';

const ChemicalSpill = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M6.762 6.15a5.951 5.951 0 01-2.608.521.5.5 0 00-.466.7l2.582 5.741a.494.494 0 00.83.115 5.936 5.936 0 012.122-1.6l9.652-4.339a3.075 3.075 0 001.8-3.447 3 3 0 00-4.158-2.072L6.762 6.15zM7.249 20.5a2 2 0 01-4 0c0-.79 1.023-2.24 1.605-3a.5.5 0 01.789 0c.583.76 1.606 2.21 1.606 3zM8.945 11.747l-1.23-2.736M11.682 10.517l-.821-1.825M14.418 9.287l-1.231-2.736M17.154 8.057l-.82-1.825"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

ChemicalSpill.displayName = 'ChemicalSpillIcon';

export default ChemicalSpill;
